(function () {
  function initMap(container) {
    if (!container || container.dataset.mapReady === 'true') return;

    var jsonEl = container.parentElement && container.parentElement.querySelector('[data-adios-map-json]');
    var markers = [];

    if (jsonEl) {
      try {
        markers = JSON.parse(jsonEl.textContent || '[]');
      } catch (e) {
        return;
      }
    }

    if (!markers.length || typeof window.L === 'undefined') return;

    var map = window.L.map(container, {
      scrollWheelZoom: false,
      tap: true
    });

    window.L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
    }).addTo(map);

    var bounds = [];

    markers.forEach(function (marker) {
      var lat = parseFloat(marker.lat);
      var lng = parseFloat(marker.lng);
      if (isNaN(lat) || isNaN(lng)) return;

      var popup = '<strong>' + marker.name + '</strong>';
      if (marker.address) popup += '<br>' + marker.address;
      if (marker.phone) popup += '<br><a href="tel:' + marker.phone + '">' + marker.phone + '</a>';

      window.L.marker([lat, lng]).addTo(map).bindPopup(popup);
      bounds.push([lat, lng]);
    });

    if (bounds.length === 1) {
      map.setView(bounds[0], 11);
    } else if (bounds.length > 1) {
      map.fitBounds(bounds, { padding: [40, 40] });
    }

    container.dataset.mapReady = 'true';
  }

  function loadLeaflet(callback) {
    if (window.L) {
      callback();
      return;
    }

    if (!document.getElementById('leaflet-css')) {
      var link = document.createElement('link');
      link.id = 'leaflet-css';
      link.rel = 'stylesheet';
      link.href = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.css';
      document.head.appendChild(link);
    }

    if (!document.getElementById('leaflet-js')) {
      var script = document.createElement('script');
      script.id = 'leaflet-js';
      script.src = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.js';
      script.onload = callback;
      document.head.appendChild(script);
    } else {
      document.getElementById('leaflet-js').addEventListener('load', callback);
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    var mapEl = document.querySelector('[data-adios-retailer-map]');
    if (!mapEl) return;

    loadLeaflet(function () {
      initMap(mapEl);
    });
  });
})();
